import { render } from "./LoaderSpinner.vue?vue&type=template&id=59dc5992"
import script from "./LoaderSpinner.vue?vue&type=script&lang=js"
export * from "./LoaderSpinner.vue?vue&type=script&lang=js"

import "./LoaderSpinner.vue?vue&type=style&index=0&id=59dc5992&lang=scss"

import exportComponent from "/home/wf13/Develop/web/vue-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__